 export default [


    {
        header: 'Objectif & AutoEvaluation',
        module: 'objectiveAutoEval',
        profile: ['Admin', 'User', 'Hierarchy','AdminSuper'],
    },
    {
        title: 'Objectif',
        route: 'objectif',
        icon: 'ListIcon',
        module: 'objectiveAutoEval',
        profile: ['Admin', 'User', 'Hierarchy','AdminSuper']
    },
    {
        title: 'Auto-Evaluation',
        route: 'autoevaluation',
        icon: 'CheckSquareIcon',
        module: 'objectiveAutoEval',
        profile: ['Admin', 'User', 'Hierarchy','AdminSuper']
    }
    
   
]